import $ from 'jquery'

const newsPulldown = {
  init() {
    const $pulldown = $('.js-news-pulldown')
    if (!$pulldown.length) return

    const $btn = $pulldown.find('.js-news-pulldown-btn')
    const $list = $pulldown.find('.js-news-pulldown-list')
    const $label = $pulldown.find('.js-news-pulldown-label')
    const $newsLists = $('.js-news-list')

    $btn.on('click', function () {
      $list.toggleClass('is-open')
    })

    $list.on('click', 'button', function () {
      var year = $(this).data('year')
      $label.text($(this).text())
      $list.find('button').removeClass('is-active')
      $(this).addClass('is-active')
      $list.removeClass('is-open')

      $newsLists.hide()
      $newsLists.filter('[data-year="' + year + '"]').show()
    })

    $(document).on('click', function (e) {
      if (!$(e.target).closest('.js-news-pulldown').length) {
        $list.removeClass('is-open')
      }
    })
  },
}

export default newsPulldown
